import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/GenericServices/InvoiceDetailsGS.css';
import check from '../../../Assets/ProfileManagement/Assets-Desktop/checkbox.svg';
import checked from '../../../Assets/ProfileManagement/Assets-Desktop/checkbox-checked.svg';
import Input from '../../Shared/Input';
import UploadFile from '../../Shared/UploadFile';
import uploadEnable from '../../../Assets/ProfileManagement/Assets-Desktop/upload.svg';
import uploadDisable from '../../../Assets/ProfileManagement/Assets-Desktop/uploadDisable.svg';
import Button from '../../Shared/Button';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';

class InvoiceDetailsGS extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            invoiceNo: "",
            InvoiceAmount: "",
            serviceWindowStartDate: "05-Jun-2021 09:15",
            isCheckInvoice: false,
            loaderTime: false,
            PageDisable: false,
            FilePathInvoiceDetailsDocuments: ''
        }
    }
    toggleCheckInvoice = (props) => {
        if (!this.state.isCheckInvoice) {
            document.getElementById('uploadVAT').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('upload1').disabled = true;
            document.getElementById('vatUpload').style.color = "#C4C4C4";
            document.getElementById('vatUploadType').style.color = "#C4C4C4";
            document.getElementById('vatUploadTypeName').style.color = "#C4C4C4";
            document.getElementById('vatUploadSize').style.color = "#C4C4C4";
            document.getElementById('vatUploadSizeName').style.color = "#C4C4C4";
            document.getElementById('vatUploadIcon').src = uploadDisable;
            document.getElementById('vatFile').style.display = 'none';
        } else if (this.state.isCheckInvoice) {
            document.getElementById('upload1').disabled = false;
            document.getElementById('vatUpload').style.color = "#d42e12";
            document.getElementById('vatUploadType').style.color = "#737373";
            document.getElementById('vatUploadTypeName').style.color = "#000000";
            document.getElementById('vatUploadSize').style.color = "#737373";
            document.getElementById('vatUploadSizeName').style.color = "#000000";
            document.getElementById('vatUploadIcon').src = uploadEnable;
            document.getElementById('vatFile').style.display = 'none';
            this.setState({ FilePathInvoiceDetailsDocuments: "" });
        }
        this.setState({ isCheckInvoice: !this.state.isCheckInvoice });
    }
    handleChangeInvoiceNo = (e) => {
        this.setState({ invoiceNo: e.target.value });
    }
    handleChangeInvoiceAmount = (e) => {
        this.setState({ invoiceAmount: e.target.value });
    }
    uploadFileFunction = (uploadConfirm) => {
    }
    removeInvoiceDetailsDocumentsLink = () => {
        let path = "";
        this.setState({ FilePathInvoiceDetailsDocuments: path });
    }
    setLoaderInvoiceDetailsDocuments = (filePathURL) => {
        this.setState({ loaderTime: filePathURL });
        this.setState({ PageDisable: filePathURL });
    }
    setUploadLinkInvoiceDetailsDocuments = (filePathURL) => {
        // for loader end
        this.setState({ FilePathInvoiceDetailsDocuments: filePathURL });
        this.setState({ loaderTime: false });
        this.setState({ PageDisable: false });
    }
    handleSubmitInvoice = () => {
        this.props.history.push("/");
    }
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.InvoiceDetailsGSTitle} description={TitleDescription.InvoiceDetailsGSDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullInvoiceDetails">
                    <div id="csnobox1InvoiceDetails">
                        <div className='weathernavbar'>
                            <small id="weathername">Create Request </small>
                        </div><hr className='navbarhr' />
                        <div class="toppartInvoiceDetails">
                            <div class="InvoiceDetailsLessRCardcss">
                                <div class="InvoiceDetailsTSRTextInpSize">
                                    <small id="InvoiceDetailsRInpHeading">Invoice No.</small>
                                    <div className="pass-wrapper" id="InvoiceDetailsRInpDiv" >
                                        <Input
                                            name="InvoiceNo" placeholder="Enter Invoice No."
                                            class="input"
                                            type="text" id="InvoiceDetailsRInpCss" value={this.state.invoiceNo}
                                            onChange={this.handleChangeInvoiceNo}
                                        />
                                    </div>
                                </div>
                                <div class="InvoiceDetailsTSRTextInpSize">
                                    <small id="InvoiceDetailsRInpHeading">Invoice Amount</small>
                                    <div className="pass-wrapper" id="InvoiceDetailsRInpDiv" >
                                        <div class="InvoiceDetailsRContainer">
                                            <div class="InvoiceDetailsR"><small id="InvoiceDetailsRValue">R</small></div>
                                            <Input
                                                name="InvoiceAmount" placeholder="Enter Invoice Amount"
                                                class="input"
                                                type="text" id="InvoiceDetailsRInpCss" value={this.state.invoiceAmount}
                                                onChange={this.handleChangeInvoiceAmount}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="InvoiceDetailsRInpSize">
                                    <small id="InvoiceDetailsRInpHeading">Service Window Start Date & Time</small>
                                    <div class="InvoiceDetailsRLowerText">{this.state.serviceWindowStartDate}</div>
                                </div>
                                <div class="InvoiceDetailsCheckBoxDiv">
                                    <small onClick={this.toggleCheckInvoice}>
                                        {this.state.isCheckInvoice ?
                                            <img src={checked} id="checkicon" alt="" loading="lazy" /> :
                                            <img src={check} id="checkicon" alt="" loading="lazy" />}
                                    </small>
                                    <small class="pl-2" id="InvoiceDetailsCheckValue">Please generate invoice on my behalf</small>
                                </div>
                                <div class="InvoiceDetailsNote">The generated invoice will be sent to the registered email ID of Requester and Respondent.</div>
                                <div class="InvoiceDetailsTSRInpSize">
                                    <small id="InvoiceDetailsRInpHeading">Update Reference Documents (Optional)</small>
                                    <div className="pass-wrapper" id="InvoiceDetailsRInpDiv" >
                                        {this.state.isCheckInvoice &&
                                            <UploadFile uploaddivid="uploadVAT" idupload="upload1" name="fileupload2" setUploadConfirm={this.uploadFileFunction}
                                                upload_link="vatUpload"
                                                fileType="jpeg, jpg, png, pdf"
                                                uploadicon="vatUploadIcon"
                                                vatFile="vatFile"
                                                setFileLink={this.setUploadLinkInvoiceDetailsDocuments}
                                                removeLink={this.removeInvoiceDetailsDocumentsLink}
                                                readOnly={this.state.isCheckInvoice}
                                                setLoader={this.setLoaderInvoiceDetailsDocuments}
                                                vatUploadType="vatUploadType"
                                                vatUploadTypeName="vatUploadTypeName"
                                                vatUploadSize="vatUploadSize"
                                                vatUploadSizeName="vatUploadSizeName"
                                                pdfFileName={this.state.FilePathInvoiceDetailsDocuments}
                                                isUploadDisabled={this.state.isCheckInvoice}
                                                staticFileName={'Invoice_Documents.'}
                                            />
                                        }
                                        {!this.state.isCheckInvoice &&
                                            <UploadFile uploaddivid="uploadVAT" idupload="upload1" name="fileupload2" setUploadConfirm={this.uploadFileFunction}
                                                upload_link="vatUpload"
                                                fileType="jpeg, jpg, png, pdf"
                                                uploadicon="vatUploadIcon"
                                                vatFile="vatFile"
                                                setFileLink={this.setUploadLinkInvoiceDetailsDocuments}
                                                removeLink={this.removeInvoiceDetailsDocumentsLink}
                                                readOnly={this.state.isCheckInvoice}
                                                setLoader={this.setLoaderInvoiceDetailsDocuments}
                                                vatUploadType="vatUploadType"
                                                vatUploadTypeName="vatUploadTypeName"
                                                vatUploadSize="vatUploadSize"
                                                vatUploadSizeName="vatUploadSizeName"
                                                pdfFileName={this.state.FilePathInvoiceDetailsDocuments}
                                                isUploadDisabled={this.state.isCheckInvoice}
                                                staticFileName={'Invoice_Documents.'}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="InvoiceDetailsRBtnDiv">
                                <Button class="InvoiceDetailsRBtnCss" onClick={this.handleSubmitInvoice}>
                                    <small class="InvoiceDetailsRBtntext">Submit Invoice</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cs2footer11InvoiceDetails">
                    <Footer />
                </div>
                <div class="cs2footer22InvoiceDetails">
                    <Footer2 />
                </div>
            </div>
        );
    };
};
export default InvoiceDetailsGS;